import { backendService } from 'services';

export const postComplianceProgram  = async (data) => {
  return await backendService.post(`/compliance-program`, data);
};

export const getComplianceProgramDetails = async (id) => {
  return await backendService.get(`/compliance-program?companyKey=${id}`)
}

export const getComplianceProgramDashboard = async (id) => {
  return await backendService.get(`/compliance-program/dashboard?companyKey=${id}`)
}

export const getComplianceProgramCheck = async (id) => {
  return await backendService.get(`/compliance-program/check?companyKey=${id}`)
}

export const getComplianceProgramProgress = async (id) => {
  return await backendService.get(`/compliance-program/progress?companyKey=${id}`)
}